<template>
  <footer class="page-footer orange">
    <div class="container">
      <div class="row">
        <div class="col l6 s12">
          <h5 class="white-text"><img class="logo" src="../assets/logo.png"/></h5>
          <p class="grey-text text-lighten-4">Quonext es la compañía de software de gestión para empresas que ofrece soluciones de negocio y servicios de última tecnología. Ayudamos de manera ágil, potente y simple a las organizaciones a incrementar su rentabilidad y competitividad implementando programas de gestión efectivos, rápidos y al menor coste posible.</p>


        </div>
        <div class="col l3 s12">

        </div>
        <div class="col l3 s12">
          <h5 class="white-text">Contactar</h5>
          <ul>
            <li>902 109 606</li>
          </ul>

          <a href="https://quotravel-usermanual.readthedocs.io"><h5 class="white-text">User manual</h5></a>

          <ul>
            <li><a href="https://pedantic-williams-fc3e0c.netlify.com/"><span class="white-text">Demo website</span></a></li>
            <li><a href="http://demo.quotravel.eu"><span class="white-text">Demo admin</span></a></li>
            <li><a href="static/images/Quotravel_tech_whitepaper_v0.pdf"><span class="white-text">White paper</span></a></li>
          </ul>


        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        Made by <a class="orange-text text-lighten-3" href="https://www.quonext.com/">Quonext</a>
      </div>
    </div>
  </footer>
</template>

<script>
    export default {
        name: "footer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue